export const TYPE_ACTION = {
  DELETE: "DELETE",
  EDIT: "EDIT",
  VIEW: "VIEW",
  UPDATE: "UPDATE",
  NEW: "NEW",
  CREATE: "CREATE",
  REMARK: "REMARK",
};

export const BTN_TEXT = {
  SAVE: "Save",
  UPDATE: "Update",
  Edit: "Edit",
};

export const STATUS_OPTIONS = {
  NEW: "New",
  BOOKED: "Booked",
  CONFIRMED: "Confirmed",
  FOLLOW_UP: "Follow Up",
  OPEN_JOBCARD: "Open Jobcard",
  COMPLETED: "Completed",
  CANCELED: "Canceled",
};
